import { render, staticRenderFns } from "./threadingelement.vue?vue&type=template&id=8c019d80&"
import script from "../../ts/articleattributes/threadingelement.ts?vue&type=script&lang=js&"
export * from "../../ts/articleattributes/threadingelement.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports